import styled from "styled-components"

export const BottonbarContainer = styled.div`
    height: 10vh;
    margin: 0;
    background-color: #f2c12e;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 5vw;
    color: #ffffff;
    font-size: 1.5em;

    @media screen and (max-device-width: 1200px){
        font-size: 1em;
        height: 8vh;
    }
`